import { TableHeader } from '@/components/ui/table';
import { TooltipAdditionalInfo } from '@/warranty-v3/components/tooltip-additional-info';

export function GuaranteedSOHHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      <TooltipAdditionalInfo
        content={
          <>
            Defined as
            <br />
            <span className="rounded bg-gray-700 px-1.5 py-0.5 font-mono text-sm font-medium text-gray-400">
              guaranteed SOH - penalties
            </span>
            <br />
            (excluding predicted penalties)
          </>
        }
      >
        Guaranteed SOH
      </TooltipAdditionalInfo>
    </TableHeader>
  );
}
